import React from 'react';
import MHeader from '../components/MHeader';
import MFooter from '../components/MFooter';

function MAbout() {
  return (
    <div>
        <MHeader/>
        <div className='row'>
          <div className='col-lg-8 col-sm-12'>
            <div class=" col-12 container fs-lg-5 fs-sm-6 fw-bold lh-lg text-justify p-5">
            <h1 class="p-5 text-center mpheadings">പൈതൃക മാപ്പിംഗ്</h1>
            <p>
            14-)o നൂറ്റാണ്ടിൽ ഫോർട്ട് കൊച്ചി - മട്ടാഞ്ചേരി പ്രദേശങ്ങൾ ഉൾപ്പെടുന്ന കൊച്ചി ഒരു തുറമുഖമായും ലോകപ്രശസ്ത വിപണിയായും രൂപീകരിക്കപ്പെട്ടു. അറബികളും ചൈനക്കാരും ജൂതന്മാരും കച്ചവടത്തിനെത്തിയതിൻ്റെ പൈതൃക അടയാളങ്ങൾ കൊച്ചിയിലുണ്ട്.  പോർച്ചുഗീസുകാരും പിന്നീട് ഡച്ചുകാരും പിന്നീട് ബ്രിട്ടീഷുകാരുമാണ് ഫോർട്ട് കൊച്ചി നേരിട്ട് ഭരിച്ചത്. അതിനാൽ 16-ാം നൂറ്റാണ്ട് മുതൽ യൂറോപ്യൻ കൊളോണിയലിസത്തിൻ്റെ അവശേഷിപ്പുകൾ ഇവിടെ കാണാം. തലമുറകളായി പാർപ്പിടത്തിനും വ്യാപാരത്തിനും തൊഴിലിനുമായി ഇന്ത്യയുടെ വിവിധ ഭാഗങ്ങളിൽ നിന്ന് എത്തിയ വ്യക്തികളും കുടുംബങ്ങളും സമൂഹങ്ങളും ഫോർട്ട് കൊച്ചി - മട്ടാഞ്ചേരിക്ക് സമ്പന്നമായ സാംസ്കാരിക വൈവിധ്യം നൽകിയിട്ടുള്ളതാണ്.
            </p>
            <p>
പ്രപഞ്ചത്തെ ഒരു തുള്ളിയിലേക്ക് ആവാഹിക്കുന്ന പോലെ കൊച്ചിയുടെ പൈതൃക ഇടങ്ങളെ സംബന്ധിച്ച അറിവുകൾ ഈ വെബ്‌സൈറ്റിലേക്ക്‌ സന്നിവേശിപ്പിക്കാനും ലോകത്തെ എല്ലാവർക്കും ഉപയോഗിക്കാനാകും വിധം ലഭ്യമാക്കാനുമാണ് ഞങ്ങളുടെ ശ്രമം.
            </p>
            <p>
സാംസ്കാരിക, പൈതൃക ഇടങ്ങൾക്കായി സമർപ്പിച്ചിരിക്കുന്ന ഈ വെബ്‌സൈറ്റിൽ ഞങ്ങൾ 200 ഓളം പൈതൃകയിടങ്ങൾ ഉൾപ്പെടുത്തിയിട്ടുണ്ട്. ഈ ഇടങ്ങളുടെ പ്രാധാന്യത്തെക്കുറിച്ച് ജനങ്ങൾക്കും സഞ്ചാരികൾക്കും അറിവ് നൽകുന്നതിനും ബോധവൽകരിക്കുന്നതിനും ഈ ഇടങ്ങളെയാകെ ലോകശ്രദ്ധയിലേക്ക് എത്തിക്കുന്നതിനും ഈ വെബ്സൈറ്റിലൂടെ ലക്ഷ്യമിടുന്നു. ഫോർട്ട്കൊച്ചിയിലും മട്ടാഞ്ചേരിയിലുമായി സ്ഥിതി ചെയ്യുന്ന വിവിധ സാംസ്കാരിക പൈതൃക സ്ഥലങ്ങളെ കുറിച്ചുള്ള ജിഐഎസ് അടിസ്ഥാനമാക്കിയുള്ള വിശദാംശങ്ങൾ, ജിയോ കോർഡിനേറ്റുകൾ, വീഡിയോകൾ, ഫോട്ടോകൾ, തദ്ദേശ സ്ഥാപന - വില്ലേജ് വിവരങ്ങൾ, റിപ്പോർട്ടുകൾ എന്നിവ ഈ വെബ്സൈറ്റിലൂടെ പങ്കിടുന്നു. ഓരോ പൈതൃക ഇടങ്ങളുമായി ബന്ധപ്പെട്ട തനതായ വാസ്തുവിദ്യാ സവിശേഷതകൾ, കലാപരമായ ആവിഷ്കാരങ്ങൾ, ചരിത്ര സംഭവങ്ങൾ എന്നിവ ഹൈലൈറ്റ് ചെയ്തിട്ടുള്ളതാണ്. ഈ വെബ്സൈറ്റ് വഴി സന്ദർശകർക്ക് സാംസ്കാരിക പൈതൃക ഇടങ്ങളെ സംബന്ധിച്ച പര്യവേക്ഷണം ചെയ്യാനും അവയുടെ പ്രാധാന്യത്തെക്കുറിച്ച് പഠിക്കാനും കൊച്ചി പ്രദേശത്തെ പൈതൃക ഇടങ്ങളുടെ സാംസ്കാരിക പശ്ചാത്തലം മനസ്സിലാക്കാനും കഴിയും.
            </p>
            <p>
ഫോർട്ട്കൊച്ചി, മട്ടാഞ്ചേരി മേഖലയിലെ പൈതൃക സ്ഥലങ്ങളുടെ ജിഐഎസ് ഡാറ്റാബേസ് ഉണ്ടാക്കുകയും അതിലൂടെ ഈ ഇടങ്ങൾ സംരക്ഷിക്കുന്നതിനും പ്രചരിപ്പിക്കുന്നതിനുമുള്ള ശ്രമങ്ങൾ വികസിപ്പിക്കുക എന്നതാണ് പദ്ധതിയുടെ പ്രധാന ലക്ഷ്യം. ഈ പ്രദേശത്തെ ടൂറിസം സർക്യൂട്ടിൽ പൈതൃക കേന്ദ്രങ്ങളെ ഉൾപ്പെടുത്താനും ഭാവി ഗവേഷണത്തിനുള്ള സാധ്യതകൾ തുറക്കാനും ഇത് സഹായിക്കും.  ഫോർട്ട്കൊച്ചി മട്ടാഞ്ചേരി പ്രദേശത്തെ ജനങ്ങളുടെ ജീവിതത്തിൽ ചരിത്രം അവശേഷിപ്പിച്ച സാംസ്കാരിക പൈതൃക അടയാളങ്ങൾ രേഖപ്പെടുത്താനുള്ള ശ്രമം കൂടിയാണിത്.
            </p>
            <p>
കൊച്ചിയെയും അതിൻ്റെ പൈതൃക മഹത്വത്തെയും സ്നേഹിക്കുന്ന എല്ലാവർക്കും സ്വാഗതം...
            </p>
            <h1 class="p-5 text-center mpheadings">ജി.സി.ഡി.എ ഒരു വീക്ഷണം</h1>
            <p>G.O.(MS) നമ്പർ 19/76/LA&SWD തീയതി 23.01.1976 പ്രകാരം 24.01.1976 ന് ഗ്രേറ്റർ കൊച്ചിൻ ഡെവലപ്‌മെൻ്റ് അതോറിറ്റി നിലവിൽ വന്നു. 1108-ലെ തിരുവിതാംകൂർ ടൗൺ പ്ലാനിംഗ് ആക്‌ട് പ്രകാരം രൂപീകരിച്ച ഒരു നിയമാനുസൃത സ്ഥാപനമാണിത്. കേരള സർക്കാരിൻ്റെ തദ്ദേശ സ്വയംഭരണ വകുപ്പിന് കീഴിലാണ് ഇത് പ്രവർത്തിക്കുന്നത്.</p>
            <p>കൊച്ചി മേഖലയുടെ ആസൂത്രിത വികസനത്തിലേക്കുള്ള ആദ്യപടിയായി 1965-ൽ ഒരു ഉപദേശക സമിതി രൂപീകരിച്ചു. അതേ വർഷം തന്നെ ആസൂത്രണത്തിനും വികസനത്തിനുമായി ഒരു ജോയിൻ്റ് ടൗൺ പ്ലാനിംഗ് കമ്മിറ്റി രൂപീകരിക്കുകയും ഈ കമ്മിറ്റിയെ ട്രസ്റ്റായി ഉയർത്തുകയും ചെയ്തു. ജില്ലാ കളക്ടറുടെ അധ്യക്ഷതയിൽ കൊച്ചിൻ ടൗൺ പ്ലാനിംഗ് ട്രസ്റ്റ്. കാലക്രമേണ, കൊച്ചി നഗരത്തിൻ്റെയും പരിസരത്തിൻ്റെയും വളർച്ച ആസൂത്രിതമായി നിയന്ത്രിക്കാൻ വലിയ സജ്ജീകരണം ആവശ്യമാണെന്ന വസ്തുത അധികാരികൾക്ക് ബോധ്യപ്പെട്ടു, ഇത് 1976-ൽ ജിസിഡിഎ രൂപീകരണത്തിന് കാരണമായി.</p>
            <p>2016ലെ കേരള ടൗൺ ആൻഡ് കൺട്രി പ്ലാനിംഗ് ആക്‌റ്റിന് കീഴിലുള്ള ഒരു കോർപ്പറേറ്റാണ് അതോറിറ്റി (2016 ലെ നിയമം 9) കൂടാതെ കേരള ഗവൺമെൻ്റ് ഐബിഡ് ആക്ടിൻ്റെ ക്ലോസ് 51 പ്രകാരം വിജ്ഞാപനം ചെയ്ത G.O (P) no.47/2016/LSGD തീയതി 16 /12/2016. ആസൂത്രിതമായ ഭൗതിക വികസന പ്രക്രിയ സ്വന്തമായി കൈകാര്യം ചെയ്യുന്നതിനു പുറമേ. ഈ മേഖലയിൽ പ്രവർത്തിക്കുന്ന വിവിധ വികസന ഏജൻസികളെ ഏകോപിപ്പിച്ച് ഏകീകൃത ലക്ഷ്യമാക്കി മാറ്റുന്നതിൽ ജിസിഡിഎയ്ക്ക് ഇരട്ട റോൾ ഉണ്ട്.</p>
            <p>കൊച്ചി കോർപ്പറേഷനും 6 മുനിസിപ്പാലിറ്റികളും 33 പഞ്ചായത്തുകളും ഉൾപ്പെടുന്ന 732 ചതുരശ്ര കിലോമീറ്റർ വിസ്തൃതിയാണ് ജിസിഡിഎയുടെ അധികാരപരിധിയിലുള്ളത്. പിന്നീട് 1994-ൽ 8 ദ്വീപ് പഞ്ചായത്തുകളും കൊച്ചിൻ കോർപ്പറേഷനുമായി ചേർന്ന് ഗോശ്രീ ദ്വീപ് വികസന അതോറിറ്റി (GIDA) രൂപീകരിച്ചു; താൻതോന്നിത്തുരുത്തും വൈപ്പിൻ കോട്ടയും 100 ചതുരശ്ര കിലോമീറ്റർ വിസ്തൃതിയുള്ളതിനാൽ ജിസിഡിഎയുടെ അധികാരപരിധി 632 കിലോമീറ്ററായി പരിമിതപ്പെടുത്തി.</p>
            <p>കോർപ്പറേഷനുകൾ: ഫോർട്ട് വൈപ്പിൻ, ഗുണ്ടു ദ്വീപ് ഒഴികെയുള്ള കൊച്ചി, താന്തോന്നിത്തുരുത്ത് ഡിവിഷനുകൾ.</p>
            <p>മുനിസിപ്പാലിറ്റികൾ: ആലുവ, നോർത്ത് പറവൂർ, അങ്കമാലി, പെരുമ്പാവൂർ, തൃപ്പൂണിത്തുറ, കളമശ്ശേരി, മരട്, തൃക്കാക്കര, ഏലൂർ.</p>
            <p>പഞ്ചായത്തുകൾ: ചെല്ലാനം, കുമ്പളങ്ങി, മുളന്തുരുത്തി, ചേരാനെല്ലൂർ, കുമ്പളം, ഉദയംപേരൂർ, വടവുകോട്-പുത്തൻകുരിശ്, വാഴക്കുളം, ചൂർണിക്കര, എടത്തല, കീഴ്മാട്, ചെങ്ങമനാട്, ശ്രീമൂലനഗരം, ആലങ്ങാട്, കടുങ്ങല്ലൂർ</p>
            <ul class="mabouttexts">
              <li>ഈ നിയമത്തിലെ വ്യവസ്ഥകൾക്ക് അനുസൃതമായി, വികസന അതോറിറ്റി പ്രദേശത്ത് പദ്ധതികൾ നടപ്പിലാക്കുന്നതിനായി ഭൂമി പുനർക്രമീകരണം അല്ലെങ്കിൽ ലാൻഡ് പൂളിംഗ് അല്ലെങ്കിൽ ലാൻഡ് ബാങ്കിംഗ് പദ്ധതി തയ്യാറാക്കലും നടപ്പിലാക്കലും;</li>
              <li>വികസന അവകാശങ്ങളുടെ കൈമാറ്റം, താമസ സംവരണം മുതലായ ഉപകരണങ്ങളിലൂടെ, വികസന അതോറിറ്റി പ്രദേശത്തിനായുള്ള പദ്ധതികളിൽ വിഭാവനം ചെയ്തിട്ടുള്ള ആസൂത്രിത വികസനം പ്രോത്സാഹിപ്പിക്കുക;</li>
              <li>ആവശ്യമെങ്കിൽ പ്രത്യേക ഫംഗ്‌ഷൻ ഏജൻസികൾ സജ്ജീകരിക്കുക, കൂടാതെ അവരുടെ അതാത് പ്രവർത്തനങ്ങളുമായി ബന്ധപ്പെട്ട കാര്യങ്ങളിൽ അവരെ നയിക്കുകയും നയിക്കുകയും സഹായിക്കുകയും ചെയ്യുക;</li>
              <li>അതോറിറ്റി ഏരിയയിൽ ഈ നിയമത്തിന് കീഴിലുള്ള പദ്ധതികൾ നടപ്പിലാക്കുന്നതിനുള്ള ഏകോപനം;</li>
              <li>സർക്കാർ, ജില്ലാ ആസൂത്രണ സമിതി അല്ലെങ്കിൽ മെട്രോപൊളിറ്റൻ ആസൂത്രണ സമിതി നിർദ്ദേശിച്ചേക്കാവുന്ന (i) മുതൽ (iii) വരെയുള്ള ഇനങ്ങൾക്ക് അനുബന്ധമോ ആകസ്മികമോ അനന്തരഫലമോ ആയ മറ്റ് പ്രവർത്തനങ്ങൾ നിർവഹിക്കുക. കാലാകാലങ്ങളിൽ.</li>
            </ul>            
            </div>
          </div>
          <div className='col-lg-4 col-sm-12 container d-flex justify-content-center p-5'>
<div className='col-10 fs-lg-5 fs-sm-6  popupmaintexts'>
<div className='container' style={{padding: '20px'}}>
<div class="card" >
  <div class="row no-gutters">
    <div class="col-md-4">
      <img src="./kcp.jpg" class="card-img" alt="chairman"/>
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title"><strong>ശ്രീ. കെ ചന്ദ്രൻ പിള്ള</strong></h5>
        <h6 class="card-subtitle mb-2 text-muted">ജി.സി.ഡി.എ ചെയർമാൻ</h6>
      </div>
    </div>
  </div>
</div>
</div>
  <div className='container' style={{padding: '20px'}}>
  <div class="card" >
    <div class="row no-gutters">
      <div class="col-md-4">
        <img src="./mayor.jpg" class="card-img" alt="mayor"/>
      </div>
      <div class="col-md-8">
        <div class="card-body">
          <h5 class="card-title"><strong>ശ്രീ. എം.അനിൽ കുമാർ</strong></h5>
          <h6 class="card-subtitle mb-2 text-muted">മേയർ, കൊച്ചി</h6>
        </div>
      </div>
    </div>
  </div>
  </div>
  <div className='container' style={{padding: '20px'}}>
  <div class="card" >
    <div class="row no-gutters">
      <div class="col-md-4">
        <img src="./bony.jpg" class="card-img" alt="writer"/>
      </div>
      <div class="col-md-8">
        <div class="card-body">
          <h5 class="card-title"><strong>ശ്രീ. ബോണി തോമസ്</strong></h5>
          <h6 class="card-subtitle mb-2 text-muted">പ്രധാന അന്വേഷകൻ</h6>
        </div>
      </div>
    </div>
  </div>
  </div>  
</div>
  </div>          
        </div>
        <MFooter/>
    </div>
  );
}

export default MAbout;
